/**
 * @generated SignedSource<<5f2a27324a3007efa08612f8b00879b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuditionVideoElement_element$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ElementBase_element">;
  readonly " $fragmentType": "AuditionVideoElement_element";
};
export type AuditionVideoElement_element$key = {
  readonly " $data"?: AuditionVideoElement_element$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuditionVideoElement_element">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuditionVideoElement_element",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ElementBase_element"
    }
  ],
  "type": "ElementNode",
  "abstractKey": null
};

(node as any).hash = "93dc26c7513e50b17b2a3701a84736f2";

export default node;
